import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=08082a00&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=08082a00&prod&lang=scss&scoped=true"
import style1 from "./Help.vue?vue&type=style&index=1&id=08082a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08082a00",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
